//
export const CONFIRMATIONS_TITLE = {
    CONTACT: 'お問い合わせ',
    EST: '概算見積依頼',
};
